import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TypeService } from '../../service/lcontype/type.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { TestQueryService } from "../../test-query.service";

@Component({
  selector: 'app-tabbar',
  templateUrl: './tabbar.component.html',
  styleUrls: ['./tabbar.component.less']
})
export class TabbarComponent implements OnInit {

  newFlag:boolean = false;
  newPicData:any = {picnewid:"",title:""};
  selectId:any = "";
  saveData: any;
  constructor(
    public srv: TypeService,
    private nzMessageService: NzMessageService,
    private modalService: NzModalService,
    public http:HttpClient,
    public ml:TestQueryService
  ) { }

  ngOnInit() {
  }

  // cancel(): void {
  //   this.nzMessageService.info('click cancel');
  // }

  // confirm(): void {
  //   this.nzMessageService.info('click confirm');
  // }

  // 保存功能
  showDeleteConfirm(): void {
    if(Object.keys(this.ml.newData).length==0){
      this.openNewpage()
    }else{
      this.modalService.confirm({
        nzTitle: '是否保存数据？',
        // nzOkText: 'Yes',
        // nzOkType: 'danger',
        nzOnOk: () => {
          this.srv.sendpre(true);
          this.getServer();
        },
        // nzCancelText: 'No',
        nzOnCancel: () => {
        }
      });
    }
  }
  // 新建
  creatNew(){
    this.ml.newData = this.newPicData;
    this.newFlag = false;
    this.createBasicMessage("新建成功！");
    this.srv.sendpage(this.newPicData);
  }
  // 删除
  delete(){
    this.modalService.confirm({
      nzTitle: '是否删除该图表？',
      nzOnOk: () => {
        this.http.get(this.ml.rootIp+":8809/delete/"+this.ml.newData.picnewid).subscribe((res:any)=>{
          this.newPicData = "";
          this.srv.sendpage(this.newPicData);
        })
      },
      nzOnCancel: () => {
      }
    });
  }
  // 获取存储的数据
  getData(){
    this.http.get(this.ml.rootIp+":8809/getImage/"+this.selectId).subscribe((res:any)=>{
      if(res!=null){
        this.ml.setId({picnewid:res[0].id,title:res[0].imageName})
        this.srv.sendopen(JSON.parse(res[0].imageData))
      }else{
        this.createBasicMessage("不存在对应该id的图表！")
      }
    })
  }
  // 获取所有保存的
  getServer(){
      this.http.get(this.ml.rootIp+":8809/getImage").subscribe((res: any) => {
        this.ml.saveDashboard = res;
      })
  }
  // 获取所有发布的的
  getPublish(){
    this.http.get(this.ml.rootIp+":8809/getStates").subscribe((res: any) => {
      this.ml.publishDashboard = res;
    })
}
  // 提示框
  createBasicMessage(title:any): void {
    this.nzMessageService.info(title);
  }
  // 切换遮罩新建图表
  toggleNew(){
    this.newFlag = false;
  }
  // 切换遮罩新建图表
  openNewpage(){
    if(this.srv.saveFlag||Object.keys(this.ml.newData).length==0){
      this.newFlag = true;
      this.newPicData = {picnewid:"",title:""};
    }else{
      this.createBasicMessage("请先保存当前页面！")
    }
  }
  // 发布图形
  release(){
    if(this.srv.saveFlag){
      this.modalService.confirm({
        nzTitle: '是否发布当前图形？',
        nzOnOk: () => {
          this.http.get(this.ml.rootIp+":8809/release/"+this.ml.newData.picnewid).subscribe((res: any) => {
            this.getPublish();
          })

          this.srv.sendrelease()
        },
        nzOnCancel: () => {
        }
      });
    }else{
      this.createBasicMessage("请先保存 当前图形！")
    }
  }

}
